import { IContact } from "../../../pages/HelpAndSupport/interfaces";


class ContactMapper {
    toPersistence(domainContact: IContact): any {
        return {
            id: domainContact.id,
            message: domainContact.message,
            status: domainContact.status,
            files: domainContact.files.map((file) => ({
                file: file.file,
            })),
            subject_contact_id: domainContact.subject_contact_id,
            app_user_viewed: domainContact.app_user_viewed,
            app_user_viewed_at: domainContact.app_user_viewed_at,
            panel_user_viewed: domainContact.panel_user_viewed,
            created_at: domainContact.created_at,
            updated_at: domainContact.updated_at,
        }
    }


    toDomain(persistenceContact: any): IContact {
        return {
            id: persistenceContact.id,
            title: persistenceContact.title,
            message: persistenceContact.message,
            status: persistenceContact.status,
            files: persistenceContact.files.map((file: any) => ({
                file: file.file,
            })),
            subject_contact_id: persistenceContact.subject_contact_id,
            subject_contact: persistenceContact.subject_contact,
            messages: persistenceContact.messages?.map((message: any) => {
                return {
                    id: message.id,
                    message: message.message,
                    files: message.files ? message.files.map((file: any) => ({
                        file: file.file,
                    })) : [],
                    panel_user_id: message.panel_user_id,
                    app_user_id: message.app_user_id,
                    viewed: message.viewed,
                    viewed_at: message.viewed_at,
                    app_user: message.app_user && {
                      id: message.app_user.id,
                      name: message.app_user.name
                    },
                    panel_user: message.panel_user && {
                      id: message.panel_user.id,
                      name: message.panel_user.name
                    },
                    created_at: message.created_at,
                    updated_at: message.updated_at
                }
            }),
            panel_user_id: persistenceContact.panel_user_id,
            panel_user: persistenceContact.panel_user ? {
                id: persistenceContact.panel_user.id,
                name: persistenceContact.panel_user.name,
            } : null,
            app_user: persistenceContact.app_user,
            app_user_viewed: persistenceContact.app_user_viewed,
            app_user_viewed_at: persistenceContact.app_user_viewed_at,
            panel_user_viewed: persistenceContact.panel_user_viewed,
            created_at: persistenceContact.created_at,
            updated_at: persistenceContact.updated_at,
        }
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ContactMapper();